import { render, staticRenderFns } from "./DeliveryPrice.vue?vue&type=template&id=9ad22e5a&scoped=true&"
import script from "./DeliveryPrice.vue?vue&type=script&lang=js&"
export * from "./DeliveryPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad22e5a",
  null
  
)

export default component.exports